<template>
  <div class="wrapper">
    <div class="animated fadeIn">

      <b-breadcrumb :items="breadcrumbs"/>

      <b-row>

        <!-- LOOP SHOULD BE DIRECTLY INSIDE b-row -->
        <b-col
          v-for="data in resultData"
          :key="data.brand_id"
          cols="12"
          sm="6"
          md="4"
          lg="2"
          class="pointer mb-3 mt-3"
        >

          <b-card no-body class="bg-aqua text-center" style="height:125px">

            <!-- NORMAL BRANDS -->
            <!-- <router-link
               :to="'/style_listmeuser/'+'Quotation_pending'"
              v-if="data.brand_title != 'Accessories'"
              @click="setthebrandid(data.brand_id);"
            > -->

          <router-link
                :to="{
                  path: '/style_listmeuser/Quotation_pending',
                  query: { id: data.brand_id }
                }"
                v-if="data.brand_title != 'Accessories'"
              >
              <b-card-body>

                <h4
                  class="mb-2  mt-3 countcolor"
                  v-b-tooltip.hover
                  title="Click to See Dashboard"
                >
                  {{ data.brand_title }}
                </h4>

                <span
                  style="color: aliceblue;font-size:30px;"
                  v-b-tooltip.hover
                  title="Click to See Pending Listing"
                >
                  {{ data.pending_count ? data.pending_count : 0 }}
                </span>

              </b-card-body>
            </router-link>


            <!-- ACCESSORIES -->
            <div
              v-if="data.brand_title == 'Accessories'"
              @click="showmodalForAccessories()"
            >
              <b-card-body>

                <h4
                  class="mb-2 countcolor"
                  v-b-tooltip.hover
                  title="Click to See Dashboard"
                >
                  {{ data.brand_title }}
                </h4>

                <span
                  style="color: aliceblue;font-size:30px;"
                  v-b-tooltip.hover
                  title="Click to See Pending Listing"
                >
                  {{ pendingCountSum }}
                </span>

              </b-card-body>
            </div>

          </b-card>

        </b-col>

      </b-row>

    </div>
  </div>
</template>

<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
const axios = require('axios');
export default {
  // name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,
     ALL_Designs: 0,
    pending_for_approval: 0,
    Designapproved:0,
    designrejected: 0,

      inprogress: 0,
      approved: 0,
      pending: 0,
      received: 0,

    BOM_Uploaded: 0,
    Measurment_Chart_Uploaded: 0,
    Tech_Pack_Uploaded: 0,
    All_Files_Uploaded: 0,

     Order_pending: 0,
     Order_received: 0,
     Order_submitted: 0,
      PO_Created: 0,
      PO_Approved:0,
      PO_Updated:0,
    PO_submitted: 0,
    tna_approved: 0,
    tna_rejected: 0,
    tna_modified: 0,
    tna_uploaded: 0,
    tna_feedback: 0,


    proto_sampling_pending: 0,
    proto_sampling_rejected:0,
    proto_sampling_approved:0,
    pp_pending:0,
    pp_sampling_requested:0,
    pp_approved:0,
    pp_rejected:0,
    proto_dispatched: 0,
    pp_dispatched: 0,
    PO_Generated: 0,
    PO_initiated: 0,


    rejected: 0,
      resultData: [],
    
    Designs_Approved : 0,
    buyinghead_Approved:0,
    Designs_Rejected : 0,
    Designs_Feedback: 0,
    Designs_Pending_For_Approval : 0,
    MY_Designs: 0,
    In_Quotation: 0,
    Quotation_pending :0,
    Quotation_received:0,
    Quotation_approved:0,
    Quotation_rejected:0,
    proto_sampling_pending : 0,
    proto_sampling_requested : 0,
    proto_sampling_approved : 0,
    pp_sampling_pending : 0,
    pp_sampling_requested : 0,
    pp_sampling_approved : 0,
      PO_CreatedPO_submitted: 0,
      PO_UpdatedPO_updated:0,
    TNA_pending : 0,
    TNA_submitted : 0,
    TNA_approved : 0,
    In_Preparation:0,
    In_Production:0,
    Ready_for_Dispatch:0,
    Order_pending : 0,
    Order_submitted : 0,
    Order_received : 0,
    user_type_data:'',

       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }],
      // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      // sub_catid: "",
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result:[],
      segementid_fields: { text: "text", value: "value" },
      collectionid_fields:  { text: "text", value: "value" },
      subcatid_fields: { text: "text", value: "value" },
      poid_fields:  { text: "text", value: "value" },
      fh_approved:0,
      TAT_Breached_Fittech:0,
    }
  },
 
  created: function () {
    this.showSubcategory(this.selected_collection_id);
    this.getPoTypeList(this.sub_catid);
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    localStorage.setItem('formData', JSON.stringify({}));
    
    this.brand_id = userInfo[0].brand_assign;
    this.showCollection(this.brand_id);

   // this.sub_cat_id_arr = userInfo[0].subcat_assign;

    // this.displayDashboardData();
    // this.getBrandSegmentList();

  },
  mounted() {

    document.body.classList.add('sidebar-fixed');
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    console.log('tempLocalStorage-------->',tempLocalStorage)
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        this.showCollection(userInfo[0].brand_assign,tempLocalStorage.selected_segment_id)
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.displayDashboardData();
    this.getBrandSegmentList();
    
  },

  methods: {
     
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
          this.user_type_data = userInfo[0].user_type
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
      axios.defaults.headers.common['Origin'] = 'http://localhost:8080';

      // if (this.selected_segment_id || this.selected_collection_id || this.sub_catid || this.selected_po_id) {
      //   alert();
      // }
      // else
      // {
        console.log("collection_id's ---------->", this.selected_collection_id);
        this.Object = {
          user_id:userInfo[0].user_id,
          user_type:userInfo[0].user_type,
          brand_id: userInfo[0].brand_assign   ,
          segment_id: this.selected_segment_id ? this.selected_segment_id : null,
          collection_id: this.selected_collection_id ? this.selected_collection_id : null,
          sub_catid: this.sub_catid ? this.sub_catid : null,
          po_id: this.selected_po_id ? this.selected_po_id : null
        }
      // }
         
        
       // getDashboardCount
        
      axios.post(`${CONSTANTS.API_URL}/getdashboardcountformeuser`,this.Object)
    .then(response => {

             this.resultData = response.data.returnvalue
    })
        
        
},

    searchData:function(brand_id){
      console.log("selected_segment_id", this.selected_segment_id)
      this.updateFilters();
      this.displayDashboardData(brand_id);
    },

    // Search function api's

        /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // document.getElementById("overlay").style.display = "none";
              // this.segmentarray_list = this.result.returnvalue[0]['segment_list'];

              let tempsegement_list =[]
              this.result.returnvalue[0]['segment_list'].map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.segment_title
                  tempobj.value = item.segment_title
                  tempsegement_list.push(tempobj)

                })
              this.segmentarray_list = tempsegement_list
                
              this.segmentList_arr = this.result.returnvalue;
              this.totalRows = this.segmentList_arr[0]["segment_list"].length;

              if (this.totalRows > 0) {
                this.segment_id = this.segmentList_arr[0]["segment_list"][0][
                  "segment_id"
                ];
                this.brand_id = this.segmentList_arr[0]["segment_list"][0][
                  "brand_id"
                ];
                //this.showCollection(this.brand_id, this.segment_id);
              }

            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id, segment_id) {
      // let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : {};
      // tempLocalStorage.selected_segment_id = segment_id
      // localStorage.setItem('filters',JSON.stringify(tempLocalStorage))
      // console.log('setting localstorage in selected_segment_id---->',tempLocalStorage)
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];

      // document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      // var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

            //  this.collectionData = response.data.returnvalue.collections;
            //  console.log("collections");
            // console.log(this.collectionData)
            let tempcollction_list =[]
                response.data.returnvalue.collections.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.collection_title
                  tempobj.value = item.collection_title
                  tempcollction_list.push(tempobj)

                })
            this.collectionData = tempcollction_list;
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id) {
         // this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
          this.po_typearr = [];
          // document.getElementById("overlay").style.display = "block";

          const Obj = {
            collection_id,
            user_id:  userInfo[0].user_id,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              // document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                // this.sub_cat_id_arr = response.data.returnvalue;
                let tempsubcat_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.sub_cattitle
                  tempobj.value = item.sub_catid
                  tempsubcat_list.push(tempobj)

                })
                this.sub_cat_id_arr = tempsubcat_list
              
              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },

        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id) {
      this.selected_po_id=null;

      // document.getElementById("overlay").style.display = "block";

      // this.isBusy = true;
      const Obj = {
        subcat_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            // this.po_typearr = this.result.returnvalue;
            let temppo_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.title
                  tempobj.value = item.po_id
                  temppo_list.push(tempobj)

                })
              this.po_typearr = temppo_list
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
        console.log(filters);
        console.log(this.selected_po_id);
      },

    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];     
      this.selected_segment_id = null,
      this.selected_collection_id = null,
      this.sub_catid = null,
      this.selected_po_id = null,
      localStorage.removeItem('filters');
      this.showCollection(this.brand_id)
      this.showSubcategory(this.selected_collection_id)
      this.getPoTypeList(this.sub_catid)
      this.displayDashboardData();
     

    },

  }
}

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
      width: 150px;
  height: 140px;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
   width: 150px;
  height: 140px;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
     width: 150px;
  height: 140px;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
       width: 150px;
  height: 140px;
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  width: 150px;
  height: 140px;
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}

</style>
